import FormItem from "@components/formItem";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems.js";
import { getUser } from "@utils";
import React from "react";
import PaymentSelect from "../../../../../components/paymentSelect/index.jsx";
import { Box, BoxTitle, Content, ContentTitle, StakeFieldWrapper } from "../baseItems";
import Base from "./base";

export default class Crypto extends Base {
	onSelectCryptocurrency(e) {
		this.setState(
			{
				cryptocurrency: e.label,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	getStep1(translate) {
		const { cryptocurrency } = this.state;
		const options = [
			{ value: 0, label: translate("PLEASE_SELECT") },
			{ value: 1, label: "BTC" },
			{ value: 2, label: "ETH" },
			{ value: 3, label: "LTC" },
			{ value: 4, label: "XRP" },
			{ value: 5, label: "BCH" },
		];
		let selectedCrypto = cryptocurrency
			? options.find((o) => o.label === cryptocurrency).value
			: 0;
		return (
			<Content>
				<ContentTitle data-testid="step-deposit-amount-title">{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}

					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<BoxWrapper>
					<FormItem onRegister={() => this.registerField({ name: "cryptocurrency" })}>
						<Box>
							<BoxTitle data-testid="step-deposit-amount-crypto-picker-label">{translate("Select_Crypto_Currency")}</BoxTitle>
							<PaymentSelect
								data-testid="step-deposit-amount-crypto-picker"
								options={options}
								value={selectedCrypto}
								onLoad={() => this.registerField({ name: "cryptocurrency" })}
								handleSelect={this.onSelectCryptocurrency.bind(this)}
							/>
						</Box>
					</FormItem>
				</BoxWrapper>
			</Content>
		);
	}

	makeExternalPayment(newStep) {
		const { stake, cryptocurrency, selectedCurrency } = this.state;
		let payload = {
			sessionId: getUser().sessionId,
			priceAmount: `${stake}`,
			priceCurrency: selectedCurrency,
			language: this.getActiveLanguageCode(),
			payCurrency: cryptocurrency ? cryptocurrency : "BTC",
		};
		this.props.externalFunc.depositCrypto(payload, (data) => {
			this.setState({
				externalUrl: data.hosted_page_url,
				currentStep: newStep,
			});
		});
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		const { stake, cryptocurrency, selectedCurrency } = this.state;
		let payload = {
			sessionId: getUser().sessionId,
			priceAmount: `${stake}`,
			priceCurrency: selectedCurrency,
			language: this.getActiveLanguageCode(),
			payCurrency: cryptocurrency ? cryptocurrency : "BTC",
			claimsBonus: true,
			bonusId,
		};
		this.props.externalFunc.depositCrypto(payload, (data) => {
			this.setState({
				externalUrl: data.hosted_page_url,
				currentStep: newStep,
			});
		});
	}
}
